import { FeatureFlagValues } from '@/core/featureFlags';
import useLocale from '@/hooks/useLocale';
import { buildCartUrl } from '@/lib/cart/helpers';
import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

export const useCartUrl = ({
  cartVariation,
}: {
  cartVariation: FeatureFlagValues['money_enable-cart-next-js-migration'];
}) => {
  const locale = useLocale();
  const searchParams = useSearchParams();
  const a11yEnabled = searchParams?.get('UsableNetAssistive') === 'true';

  const cartHref = useMemo(() => {
    const href = buildCartUrl(cartVariation, locale);

    if (!a11yEnabled) return href;

    return href.includes('?')
      ? `${href}&UsableNetAssistive=true`
      : `${href}?UsableNetAssistive=true`;
  }, [a11yEnabled, locale, cartVariation]);

  return cartHref;
};
